import FilterAltOff from '@mui/icons-material/FilterAltOff';
import {
    Box,
    Chip,
    styled,
    useMediaQuery,
    useTheme,
    Tooltip,
} from '@mui/material';
import { useWidgetPositionContext } from 'lib/layout/context/WidgetPositionContext';
import React from 'react';
import { useTranslation } from 'react-i18next';

const StyChip = styled(Chip, {
    name: 'StyChip',
})(({ theme }) => ({
    backgroundColor: theme.palette.primary.background,
    color: theme.palette.primary.main,
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
}));

const StyIconBox = styled(Box, {
    name: 'StyIconBox',
})(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.primary.background,
    borderRadius: '100%',
    padding: theme.spacing(1),
    height: '32px',
    width: '32px',

    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
}));

const GridChartNoDashboardFilterChip = () => {
    const { t } = useTranslation();
    const { breakpoints } = useTheme();
    const isSmallScreen = useMediaQuery(breakpoints.down('lg'));
    const widgetSize = useWidgetPositionContext();
    if (isSmallScreen || widgetSize[widgetSize.currentBreakpoint].w < 4) {
        return (
            <Tooltip title={t('chart.noDashboardFilters')}>
                <StyIconBox>
                    <FilterAltOff color="primary" fontSize="small" />
                </StyIconBox>
            </Tooltip>
        );
    }
    return (
        <StyChip
            icon={<FilterAltOff color="primary" fontSize="small" />}
            label={t('chart.noDashboardFilters')}
        />
    );
};

export default GridChartNoDashboardFilterChip;
